import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import Theme from 'Theme';
import PropTypes from 'prop-types';

const styleSheet = StyleSheet.create({
    container: {
        alignSelf: 'stretch',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: Theme.negativeColor,
        minHeight: 100,
        padding: 20
    },
    text: {
        fontFamily: Theme.regularFont,
        fontSize: 20,
        color: '#fff',
        textAlign: 'center'
    }
});

const InfoBox = ({ message, isPositive, style }) => (
    <View
        style={[
            styleSheet.container,
            {
                backgroundColor: isPositive ? Theme.positiveColor : Theme.negativeColor
            },
            style
        ]}
    >
        <Text style={styleSheet.text}>{message}</Text>
    </View>
);

InfoBox.defaultProps = {
    isPositive: false,
    style: {}
};

InfoBox.propTypes = {
    message: PropTypes.string.isRequired,
    isPositive: PropTypes.bool,
    style: PropTypes.shape({})
};

export default InfoBox;
